import React, { useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
// css
import styles from "./StaffDetail.module.scss";
import { Link, useParams } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import { CstmPagination } from "components/Common/Common";
import { useGetParentTasksClientsListQuery, useGetStaffClientsListQuery } from "store/services/staff";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { MANAGE_PARENT, MANAGE_PARENT_TASK_LIST, MANAGE_STAFF } from "config/paths";

const ParentClients = () => {

  const { id: staffId, taskType } = useParams();

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({ search: "", sort: { column: "id", direction: "desc" } });

  // const { data, isLoading, isError, isFetching } = useGetStaffClientsListQuery({ id: staffId, taskType, payload: { page: currentPage, limit: pageSize, ...filter } });
  const { data, isLoading, isError, isFetching } = useGetParentTasksClientsListQuery({ id: staffId, taskType, page: currentPage, limit: pageSize, ...filter  });

  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const column = [
    {
      head: "Last Name",
      accessor: "LastName",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item?.lastname || "--"}</h6>
      ),
    },
    {
      head: "First Name",
      accessor: "FirstName",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item?.firstname || "--"}</h6>
      ),
    }
  ];

  const resetFilter = () => {
    setFilter({ search: "", sort: { column: "id", direction: "desc" } });
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };
console.log('filter', filter)
  return (
    <>
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid>
          <Row>
            <Col
              lg="12"
              className=""
            >
              <Row>
                <Col lg="12" className="my-3">
                  <div className="my-3">
                    <ul className="list-unstyled mb-0 d-flex align-items-center">
                      <li className="m-0 p-0">
                        <Link
                          className="themeBlue fw-sbold"
                          style={{ textDecoration: "underline" }}
                          to={MANAGE_PARENT}
                        >
                          Manage Parent
                        </Link>
                      </li>
                      <li className="">
                        <h5 className="m-0 fw-bold themeBlue">
                          / Clients
                        </h5>
                      </li>
                    </ul>
                  </div>
                  <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                    <div className="left">
                      <TableHeader
                        heading={"Clients"}
                        handleFilterChange={handleFilterChange}
                        filter={filter}
                        resetFilter={resetFilter}
                        searchPlaceholder="Client Last, First Name"
                      />
                    </div>
                  </div>
                </Col>
                <Col lg="12" className="my-3">
                  <div className="table-outer">
                    {isLoading ? (
                      <div style={{ height: "200px" }}>
                        <LoadingIndicator />
                      </div>
                    ) : isError ? (
                      <ErrorComponent />
                    ) : (
                      <>
                        {(isFetching) && <LoadingOverlay />}
                        <TableLayout
                          data={data?.records || []}
                          column={column}
                          url={MANAGE_PARENT_TASK_LIST.replace(":taskType", taskType).replace(":clientId", staffId).replace("/:staffId", "")}
                        />
                      </>
                    )}
                    <CstmPagination
                      totalPages={totalPages}
                      activePage={currentPage}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

        </Container>
      </section>
    </>
  );
};

export default ParentClients;